import { router } from '@/router'
import Vue from 'vue'
import VueYandexMetrika from 'vue-yandex-metrika'

if (process.env.VUE_APP_YANDEX_METRIKA) {
  Vue.use(VueYandexMetrika, {
    id: process.env.VUE_APP_YANDEX_METRIKA,
    router,
    env: process.env.NODE_ENV,
    debug: process.env.NODE_ENV !== 'production',
    options: {
      webvisor: true,
    },
  })
}
